export const NO_ADDITIONAL_PROTECTION_ID = 'no-additional-protection'
export const ADD_ON_PRICE_NOTE = 'Price confirmed after vehicle inspection'

export interface ProtectionAddOn {
  id: string
  name: string
  shortName: string
  description: string
  surfaces?: string[]
}

export const protectionAddOns: ProtectionAddOn[] = [
  {
    id: 'glass-protection',
    name: 'Glass Protection',
    shortName: 'Glass',
    description:
      'Improve visibility in wet weather with a hydrophobic coating that repels water, dirt and road grime while making glass easier to clean.',
  },
  {
    id: 'wheel-protection',
    name: 'Wheel Protection',
    shortName: 'Wheels',
    description:
      'Protect your wheels from brake dust, road grime and contaminants, making regular cleaning quicker and easier.',
  },
  {
    id: 'exterior-trim-protection',
    name: 'Exterior Trim Protection',
    shortName: 'Exterior Trim',
    description:
      'Restore and protect exterior plastic trim from fading, UV exposure and environmental contaminants while maintaining a rich, factory-like finish.',
  },
  {
    id: 'interior-protection',
    name: 'Interior Protection',
    shortName: 'Interior',
    description:
      'Protect the surfaces you interact with every day using professional GYEON interior protection. Designed to help resist spills, stains, UV damage and everyday wear while making interior surfaces easier to maintain.',
    surfaces: [
      'Leather',
      'Fabric & Upholstery',
      'Carpets & Floor Mats',
      'Plastic & Vinyl Trim',
    ],
  },
]

export type AddOnChoice = 'unset' | 'none' | 'selected'

export interface AddOnSelection {
  addOnIds: string[]
  noAdditionalProtection: boolean
}

export function emptyAddOnSelection(): AddOnSelection {
  return { addOnIds: [], noAdditionalProtection: false }
}

export function normalizeAddOnSelection(selection: AddOnSelection): AddOnSelection {
  const addOnIds = selection.addOnIds.filter(Boolean)
  return {
    addOnIds,
    noAdditionalProtection: addOnIds.length === 0,
  }
}

export function addOnChoiceFromSelection(selection: AddOnSelection): AddOnChoice {
  if (selection.addOnIds.length > 0) return 'selected'
  return 'none'
}

export function toggleAddOn(selection: AddOnSelection, addOnId: string): AddOnSelection {
  const alreadySelected = selection.addOnIds.includes(addOnId)
  const addOnIds = alreadySelected
    ? selection.addOnIds.filter((id) => id !== addOnId)
    : [...selection.addOnIds, addOnId]

  return {
    addOnIds,
    noAdditionalProtection: false,
  }
}

export function chooseNoAdditionalProtection(): AddOnSelection {
  return {
    addOnIds: [],
    noAdditionalProtection: true,
  }
}

export function selectedAddOns(selection: AddOnSelection) {
  return protectionAddOns.filter((item) => selection.addOnIds.includes(item.id))
}
